/**
 * Maps each application capability to the policy name registered in the policy
 * registry (the very policies the backend evaluates for the matching operations).
 *
 * Several capabilities may point at the same policy: the keys describe the place
 * in the interface, the values the authorization. Renaming or merging a policy
 * happens here only, the components stay untouched.
 */
export const POLICIES = {
    // create/edit/delete a custom fulfilment
    fulfilmentCreate: "taxc:tcf:v0:fulfilment.write",
    fulfilmentEdit: "taxc:tcf:v0:fulfilment.write",
    fulfilmentDelete: "taxc:tcf:v0:fulfilment.write",
    // link/unlink a tax payer to a fulfilment; applying the Tax Tinder
    // suggestions in bulk is a mass association.
    // NB: should link and unlink ever be split into two policies, the unlink
    // toggle in the linking drawer (FulfilmentLinkingTaxPayer) needs gating too
    // — today it is covered because it shares this policy.
    taxPayerLink: "taxc:tcf:v0:fulfilment.associate",
    taxPayerUnlink: "taxc:tcf:v0:fulfilment.associate",
    taxTinderApply: "taxc:tcf:v0:fulfilment.associate",
    // create/edit/delete/change status of a manual activity
    activityManage: "taxc:tcf:v0:activity.write",
    // close/reopen a fulfilment
    fulfilmentClose: "taxc:tcf:v0:activity.write",
    fulfilmentReopen: "taxc:tcf:v0:activity.write",
} as const;

/** Application capability: how the components name it. */
export type PolicyKey = keyof typeof POLICIES;

export const POLICY_KEYS = Object.keys(POLICIES) as readonly PolicyKey[];

/** Registry policy name: what actually gets evaluated. */
export type PolicyName = (typeof POLICIES)[PolicyKey];

/** Policies to evaluate: the distinct names, not one per capability. */
export const POLICY_NAMES: readonly PolicyName[] = [
    ...new Set(Object.values(POLICIES)),
];
